import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Loader } from '../../Elements/Loader';
import { Item } from './components/Item';
import { LoaderSlot, Wrapper } from './styled';
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/naming-convention
function _SegmentedControl(props, ref) {
    const { options, selectedValue, onChange, isOptionSelected, disabled, isLoading, formatOptionLabel, dataTestId, numberOfColumns } = props;
    const columns = numberOfColumns ?? options.length;
    return (_jsx(Wrapper, { ref: ref, "data-testid": dataTestId, "$numberOfColumns": columns, "$disabled": disabled, children: isLoading ? (_jsx(LoaderSlot, { children: _jsx(Loader, {}) })) : (options.map((option) => (_jsx(Item, { option: option, selectedValue: selectedValue, columns: columns, allDisabled: disabled, isOptionSelected: isOptionSelected, onChange: onChange, formatOptionLabel: formatOptionLabel }, String(option.value))))) }));
}
export const SegmentedControl = forwardRef(_SegmentedControl);
